<script setup>
import {useStore} from "vuex";

const store = useStore();
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import Uploader from "@/components/Uploader.vue";
const router = useRouter();
const currAdmin = computed(() => store.state.currAdmin);

function imageSelected(url){
}
</script>
<template>
  <div class="card card-profile">
    <img
      src="https://inv.tvcnews.co/images/main-slider/image-1.jpg"
      alt="Image placeholder"
      class="card-img-top"
    />
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
          <a href="javascript:;">
<!--            <img src="../../assets/img/team-2.jpg" class="rounded-circle img-fluid border border-2 border-white"/>-->
          </a>
        </div>
      </div>
    </div>
    <div class="card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3">
      <div class="d-flex justify-content-between">
<!--        <a href="javascript:;" class="btn btn-sm btn-info mb-0 d-block d-lg-none">-->
<!--          <i class="ni ni-collection"></i>-->
<!--        </a>-->
        <Uploader :IsMultid="true" v-if="currAdmin?.Id" @urlEvent="imageSelected" :IsImage="true" :IsVideo="false" :DataId="currAdmin.Id" Section="Admins" />

        <!--        <a-->
<!--          href="javascript:;"-->
<!--          class="btn btn-sm btn-dark float-right mb-0 d-none d-lg-block">پیام های شما</a>-->
<!--        <a-->
<!--          href="javascript:;"-->
<!--          class="btn btn-sm btn-dark float-right mb-0 d-block d-lg-none"-->
<!--        >-->
<!--          <i class="ni ni-email-83"></i>-->
<!--        </a>-->
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-center">
            <div class="d-grid text-center">
<!--              <span class="text-lg font-weight-bolder">22</span>-->
<!--              <span class="text-sm opacity-8" style="font-family: Tahoma">پیام جدید</span>-->
            </div>
<!--            <div class="d-grid text-center mx-4">-->
<!--              <span class="text-lg font-weight-bolder">10</span>-->
<!--              <span class="text-sm opacity-8">Photos</span>-->
<!--            </div>-->
<!--            <div class="d-grid text-center">-->
<!--              <span class="text-lg font-weight-bolder">89</span>-->
<!--              <span class="text-sm opacity-8">Comments</span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="text-center mt-4">
        <h5 style="font-family: Tahoma">
          {{ currAdmin?.Name }}
          <span class="font-weight-light"></span>
        </h5>
        <div class="h6 font-weight-300">
          <i class="ni location_pin mr-2"></i>{{ (currAdmin?.Address?.Main?currAdmin?.Address?.Main:'')}}{{currAdmin?.Address?.Postcode?", "+currAdmin?.Address?.Postcode:'' }}
        </div>
<!--        <div class="h6 mt-4">-->
<!--          <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - -->
<!--          Creative Tim Officer-->
<!--        </div>-->
<!--        <div>-->
<!--          <i class="ni education_hat mr-2"></i>University of Computer Science-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
